import axios from "axios";

const baseUrl = "https://pspp-integrated.com/server";

export const apiGet = (url, headers = {}) => {
  return axios.get(baseUrl + url, headers).then((response) => {
    return response.data;
  });
};

export const apiPost = (url, data, headers = {}) => {
  return axios.post(baseUrl + url, data, headers).then((response) => {
    return response.data;
  });
};

export const apiUpload = (url, data) => {
  let uploadUrl = baseUrl + url;
  if (url.includes('http')) {
    uploadUrl = url;
  }

  return axios
    .post(uploadUrl, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const rawGet = (url) => {
  return axios.get(url).then((response) => {
    return response.data;
  });
};
